import { notification } from '@components/notification';
import { ApiEndPoints, QueryKey } from '@constants';
import { httpRequest, queryClient } from '@lib';
import { useMutation } from '@tanstack/react-query';

export const createCookieRecord = async (payload) => {
  try {
    const { data } = await httpRequest.post(ApiEndPoints.CREATE_COOKIE_RECORD, payload);
    return data;
  } catch (err) {
    throw new Error(err);
  }
};

export const useCreateCookieRecordQuery = () => {
  return useMutation({
    mutationFn: createCookieRecord,
    onSuccess: (respData) => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.COOKIE_RECORDS] });
      notification.success(respData.message);
    },
  });
};
